import axios from './index';

// 获取登录后用户的信息-所有
export const fetchUserCenterInfo = () => {
  return axios.get('/api/user/center');
};

// 更新登录邮箱
export const updateEmail = (data) => {
  return axios.post('/api/user/updateEmail', data);
};

// 获取修改邮箱验证码
export const sendVerifyCode = (data) => {
  return axios.post('/api/user/sendVerifyCode', data);
};

// 修改密码
export const updatePwd = (data) => {
  return axios.post('/api/user/updatePassword', data);
};

// 切换账号类型
export const changeRole = (data) => {
  return axios.post('/api/user/changeRole', data);
};

// 编辑姓名
export const updateUserInfo = (data) => {
  return axios.post('/api/user/updateUserName', data);
};

// 查看收藏的简历信息
export const fetchFavoriteList = (data) => {
  return axios.get('/api/user/favoriteList', data);
};

// 查看企业信息
export const fetchCompanySimple = (data) => {
  return axios.get('/api/user/companySimple', data);
};

// 重新认证企业信息
export const changeCompany = (data) => {
  return axios.post('/api/user/changeCompany', data);
};
